import { DotLegalDialog, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import { ProcessingActivityReportReceipt } from "../ProcessingActivityReport.types";
import { Box } from "@mui/material";

export interface IProcessingActivityReportReceiptDialogProps {
    receipt: ProcessingActivityReportReceipt;
    onDialogClose: () => void;
}

function ProcessingActivityReportReceiptDialog(props: IProcessingActivityReportReceiptDialogProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalDialog
            buttonOkText={translateString("close")}
            header={props.receipt.header}
            open
            onDialogClose={props.onDialogClose}
            onOkClick={props.onDialogClose}
            size="sm"
        >
            <Box sx={{ display: "flex", justifyContent: "center", whiteSpace: "pre-wrap" }}>
                <DotLegalHeader center fontWeight={400} headerStyle={"small"}>
                    {props.receipt.content}
                </DotLegalHeader>
            </Box>
        </DotLegalDialog>
    );
}

export default ProcessingActivityReportReceiptDialog;
